import Select, { Value } from 'domains/core/components/Select';
import { VoiceContentInteraction } from 'pages/ContentVoiceBuilderPage/types';
import { updateInteraction } from 'pages/ContentVoiceBuilderPage/voiceCallActions';

const keypadOptions = [
    { label: '0', value: '0' },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
];

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    index: number;
    interaction: VoiceContentInteraction;
    selectedKeypadOptions: string[];
};

const KeypadOptionSelect = ({ dispatchVoiceContentAction, index, interaction, selectedKeypadOptions }: Props) => {
    const handleKeypadOptionSelect = (value: string) => {
        const updatedInteraction = {
            ...interaction,
            keypadOption: value,
        };
        dispatchVoiceContentAction(updateInteraction(updatedInteraction, index));
    };

    const getKeypadOptions = (selectedOption?: string): Value[] => {
        const filteredOptions = selectedKeypadOptions.filter((option: string) => option !== selectedOption);
        return keypadOptions.filter(({ value }) => !filteredOptions.includes(value));
    };
    const availableKeypadOptions = getKeypadOptions(interaction?.keypadOption);

    return (
        <Select
            label="Number"
            onChange={(e: any) => handleKeypadOptionSelect(e.target.value)}
            sx={{ width: '100px' }}
            type="string"
            value={interaction?.keypadOption}
            values={availableKeypadOptions}
        />
    );
};

export default KeypadOptionSelect;
